import React from 'react';
import { Grid } from '~/components';
import StatusCell from './StatusCell';
import DateCell from './DateCell';
import NameCell from './NameCell';
import AddressCell from './AddressCell';
import NextStepCell from './NextStepsCell';
import AttachmentsCell from './AttachmentsCell';
import { asyncState } from '~/hooks';
import { useSearchHistory } from '../context';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { SORT_ORDER } from '~/components/Grid/util';
import { sortDates, sortStrings } from '~/util/sorters';


const headerClassName = 'bg-gray-50 p-4 border-b text-left';
const props = {
    className: 'p-4 text-sm border-b'
};

const columns = [
    {
        title: 'Your File No.',
        field: 'fileNumber',
        headerClassName,
        props
    },
    {
        title: 'Submitted On',
        cell: DateCell('submitted'),
        sorter: (a,b) => sortDates(a.submitted, b.submitted),
        headerClassName,
        props
    },
    {
        title: 'Address',
        cell: AddressCell,
        sorter: (a,b) => {
            return sortStrings(
                `${a.streetNumber} ${a.streetName} ${a.streetSuffix}`,
                `${b.streetNumber} ${b.streetName} ${b.streetSuffix}`
            );
        },
        headerClassName,
        props
    },
    {
        title: 'County',
        field: 'county',
        headerClassName,
        props
    },
    {
        title: 'Current Owner',
        cell: NameCell,
        sorter: (a,b) => {
            return sortStrings(
                `${a.ownerFirstName} ${a.ownerLastName}`.toLowerCase(),
                `${b.ownerFirstName} ${b.ownerLastName}`.toLowerCase()
            );
        },
        headerClassName,
        props
    },
    {
        title: 'Status',
        cell: StatusCell,
        sorter: (a,b) => a.statusId - b.statusId,
        headerClassName,
        props
    },
    {
        title: 'Attachments',
        cell: AttachmentsCell,
        canSort: false,
        headerClassName,
        props
    },
    {
        title: '',
        key: 'actions',
        cell: NextStepCell,
        headerClassName,
        props
    }
];

const SearchHistoryGrid = () => {

    const { filteredRows, policySearches } = useSearchHistory();

    const isLoading = policySearches.status == asyncState.PENDING;
    const rows = Array.isArray(filteredRows) ? filteredRows : [];

    return (
        <div className='w-full flex flex-col items-stretch justify-center'>
            {isLoading ? (
                <AiOutlineLoading3Quarters className='text-primary-50 animate-spin mt-10' size='2rem' />
            ) : (
                <Grid 
                    usePagination
                    data={rows} 
                    columns={columns}
                    initialState={{
                        sort: {
                            column: 'Submitted On',
                            order: SORT_ORDER.DESC
                        }
                    }}
                    className='w-full my-4 rounded-md'
                    tableClassName='mb-2'
                />
            )}
        </div>
    );
};

export default SearchHistoryGrid;